/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Col } from 'react-bootstrap';
import uuid from 'uuid/v1';
import { get, find, isEmpty, map } from 'lodash';

import * as layerOps from '../../../api/Layers/layer-operations';

import { LAYER_TYPES } from '../../../api/Layers/Layers';

import Loading from '../../components/Loading';

const JoinButton = ({ geojsonLoading, clickAction }) => {
  if (geojsonLoading) return <Loading />;
  return (
    <Col xs={2}>
      <Button disabled={geojsonLoading} variant="primary" onClick={clickAction}>
        Join
      </Button>
    </Col>
  );
};

JoinButton.propTypes = {
  geojsonLoading: PropTypes.bool.isRequired,
  clickAction: PropTypes.func.isRequired
};

class LayerJoinFields extends Component {
  state = {
    selectedGeoJSONLayerId: layerOps.getGeoJSONId(this.props.layer),
    selectedGeoJSONLayerProp: layerOps.getGeoJSONPropToJoin(this.props.layer),
    selectedThematicLayerId: layerOps.getThematicId(this.props.layer),
    selectedThematicLayerKey: layerOps.getThematicKeyToJoin(this.props.layer)
  };

  handleGeoJSONChange = event => this.setState({ selectedGeoJSONLayerId: event.target.value });

  handleThematicChange = event => this.setState({ selectedThematicLayerId: event.target.value });

  handleGeoJSONPropChange = event =>
    this.setState({ selectedGeoJSONLayerProp: event.target.value });

  handleThematicKeyChange = event =>
    this.setState({ selectedThematicLayerKey: event.target.value });

  render() {
    const {
      geojsonLayers,
      geojsonLoading,
      joinLayers,
      layer,
      layerType,
      thematicLayers
    } = this.props;
    const {
      selectedGeoJSONLayerId,
      selectedGeoJSONLayerProp,
      selectedThematicLayerId,
      selectedThematicLayerKey
    } = this.state;

    let selectedGeoJSONLayer = find(geojsonLayers, ['_id', selectedGeoJSONLayerId]) || {};
    let selectedThematicLayer = find(thematicLayers, ['_id', selectedThematicLayerId]) || {};

    if (isEmpty(selectedGeoJSONLayer)) {
      selectedGeoJSONLayer = get(this.props, 'geojsonLayers[0]', {});
    }
    if (isEmpty(selectedThematicLayer))
      selectedThematicLayer = get(this.props, 'thematicLayers[0]', {});

    const geojsonProps = layerOps.getGeoJSONProps(selectedGeoJSONLayer);
    const thematicKeyList = layerOps.getThematicKeyList(selectedThematicLayer);

    if (LAYER_TYPES.JOIN === layerType) {
      return (
        <>
          <Form.Group>
            <Form.Label>Select Geographic Layer</Form.Label>
            <Form.Control
              as="select"
              value={selectedGeoJSONLayerId}
              onChange={this.handleGeoJSONChange}
              name="geojsonLayer"
            >
              {map(geojsonLayers, geojsonLayer => (
                <option key={uuid()} value={layerOps.getId(geojsonLayer)}>
                  {layerOps.getName(geojsonLayer)}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Geographic Identifier</Form.Label>
            <Form.Control
              as="select"
              name="geojsonProp"
              value={selectedGeoJSONLayerProp}
              onChange={this.handleGeoJSONPropChange}
            >
              {map(geojsonProps, prop => (
                <option key={uuid()} value={prop.name}>
                  {prop.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Select Thematic Layer</Form.Label>
            <Form.Control
              as="select"
              value={selectedThematicLayerId}
              onChange={this.handleThematicChange}
              name="thematicLayer"
            >
              {map(thematicLayers, thematicLayer => (
                <option key={uuid()} value={layerOps.getId(thematicLayer)}>
                  {layerOps.getName(thematicLayer)}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Thematic Identifier</Form.Label>
            <Form.Control
              as="select"
              name="thematicKey"
              value={selectedThematicLayerKey}
              onChange={this.handleThematicKeyChange}
            >
              {map(thematicKeyList, key => (
                <option key={uuid()} value={key}>
                  {key}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Sørensen-Dice Minimun Value</Form.Label>
            <Form.Control
              type="number"
              name="sorensenDiceMinimun"
              defaultValue={layerOps.getSorensenDiceMinimun(layer)}
              min={0}
              max={1}
            />
          </Form.Group>
          <Form.Group>
            <JoinButton geojsonLoading={geojsonLoading} clickAction={joinLayers} />
          </Form.Group>
        </>
      );
    }
    return '';
  }
}
LayerJoinFields.propTypes = {
  layer: PropTypes.object.isRequired,
  layerType: PropTypes.string.isRequired,
  geojsonLayers: PropTypes.array.isRequired,
  thematicLayers: PropTypes.array.isRequired,
  joinLayers: PropTypes.func.isRequired,
  geojsonLoading: PropTypes.bool.isRequired
};

export default LayerJoinFields;
